import { DEFAULT_LIMIT, DEFAULT_SKIP, LIMIT } from 'Src/consts/table';
import { Count } from 'Src/models/count';
import { superAdminDelete, superAdminGet, superAdminPost, superAdminPut } from './api';

export interface SuperAdminAppVersion {
  id: string;
  name?: string;
  status?: string;
  currentVersion?: string;
  minimalVersion?: string;
  lowerCurrentVersionText?: string;
  lowerMinimalVersionText?: string;
  platform?: string;
  requestRatingThresholdLaunchCount?: number;
  [key: string]: any;
}

export interface SuperAdminAppSaveData {
  name: string;
  platform: string;
  currentVersion?: string;
  minimalVersion?: string;
  lowerCurrentVersionText?: string;
  lowerMinimalVersionText?: string;
  requestRatingThresholdLaunchCount?: number;
}

export interface SuperAdminAppsFilter {
  limit?: number;
  skip?: number;
  order?: string;
  where?: any;
}

const DEFAULT_FILTER: SuperAdminAppsFilter = {
  limit: LIMIT,
  skip: DEFAULT_SKIP,
  order: 'name ASC'
};

function buildFilter(filter: SuperAdminAppsFilter = DEFAULT_FILTER): SuperAdminAppsFilter {
  return {
    where: filter.where || {},
    skip: typeof filter.skip === 'number' ? filter.skip : DEFAULT_FILTER.skip,
    limit: typeof filter.limit === 'number' ? filter.limit : DEFAULT_FILTER.limit,
    order: filter.order || DEFAULT_FILTER.order
  };
}

export function getSuperAdminApps(filter: SuperAdminAppsFilter = DEFAULT_FILTER): Promise<SuperAdminAppVersion[]> {
  return superAdminGet<SuperAdminAppVersion[]>('/apps', {
    params: {
      filter: buildFilter(filter)
    }
  });
}

export function getAllSuperAdminApps(where?: any): Promise<SuperAdminAppVersion[]> {
  return superAdminGet<SuperAdminAppVersion[]>('/apps', {
    params: {
      filter: {
        where: where || {},
        skip: DEFAULT_SKIP,
        limit: DEFAULT_LIMIT,
        order: DEFAULT_FILTER.order
      }
    }
  });
}

export function getSuperAdminAppsCount(where?: any): Promise<Count> {
  const config =
    typeof where !== 'undefined'
      ? {
          params: {
            filter: {
              where
            }
          }
        }
      : {};

  return superAdminGet<Count>('/apps/count', config);
}

export function getSuperAdminApp(appId: string): Promise<SuperAdminAppVersion> {
  return superAdminGet<SuperAdminAppVersion>(`/apps/${appId}`);
}

export function createSuperAdminApp(data: SuperAdminAppSaveData): Promise<SuperAdminAppVersion> {
  return superAdminPost<SuperAdminAppVersion>('/apps', data);
}

export function updateSuperAdminApp(appId: string, data: SuperAdminAppSaveData): Promise<SuperAdminAppVersion> {
  return superAdminPut<SuperAdminAppVersion>(`/apps/${appId}`, data);
}

export function deleteSuperAdminApp(appId: string): Promise<void> {
  return superAdminDelete<void>(`/apps/${appId}`);
}

export function recoverSuperAdminApp(appId: string): Promise<SuperAdminAppVersion> {
  return superAdminPost<SuperAdminAppVersion>(`/apps/${appId}/recover`, {});
}
